import * as React from 'react';

import { SubscriptionConfirmation, Instructions } from './sections';

export const Download: React.SFC = () => (
  <React.Fragment>
    <SubscriptionConfirmation />
    <Instructions />
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/presentational/views/Download/index.tsx